import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const api = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const useAdminReviews = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    ["adminReviews"],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/product/reviews`,
        api(token)
      );
      return res.data;
    },
    { enabled: !!token }
  );
};

export const useDeleteReview = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    (id) =>
      axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/product/reviews/${id}`,
        api(token)
      ),
    { onSuccess: () => qc.invalidateQueries(["adminReviews"]) }
  );
};
